import React, { useState } from "react";
import DashboardList from "../components/dashboard/DashboardList";
import { useNavigate } from "react-router-dom";
import OfficerHeader from "../components/header/officerHeader";
import dashboardIcon from "../assets/images/grid_view.png";
import dashboardIcon2 from "../assets/images/grid-view2.png";
import faqIcon from "../assets/images/faq.svg";
import chatIcon from "../assets/images/page.svg";
import logoutIcon from "../assets/images/logout.svg";
import Header from "../components/header";
import { useAuth } from "../utils/AuthContext";
import Feedback from "../components/feedback";
import sidebarImage from "../assets/images/Rectangle 5191.png";

const Desk = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("dashboard");
  const { logout } = useAuth();

  const handleSignOut = () => {
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("userId");
    logout();
    navigate("/");
  };

  return (
    <div className="flex flex-col h-[100dvh] overflow-hidden">
      <Header />
      <div className="flex-1 flex flex-col sm:flex-row overflow-hidden">

        {/* Mobile Top Navigation — visible only on small screens */}
        <div className="flex sm:hidden w-full bg-[#F3F8FF] border-b border-[#E7E5E4] px-4 py-2 gap-3 justify-between overflow-x-auto shrink-0">
          <button
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap transition-colors ${activeSection === "chatbot" ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white" : "bg-white text-black border border-[#E7E5E4]"}`}
            onClick={() => { setActiveSection("chatbot"); navigate("/botDesk"); }}
          >
            <img src={chatIcon} alt="" className="w-4 h-4" />
            Lodge Grievances
          </button>
          <button
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap transition-colors ${activeSection === "faq" ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white" : "bg-white text-black border border-[#E7E5E4]"}`}
            onClick={() => { setActiveSection("faq"); navigate("/faq"); }}
          >
            <img src={faqIcon} alt="" className="w-4 h-4" />
            FAQ
          </button>
          <button
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap transition-colors ${activeSection === "dashboard" ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white" : "bg-white text-black border border-[#E7E5E4]"}`}
            onClick={() => setActiveSection("dashboard")}
          >
            <img src={activeSection === "dashboard" ? dashboardIcon2 : dashboardIcon} alt="" className="w-4 h-4" />
            Dashboard
          </button>

        </div>

        {/* Desktop Sidebar */}
        <div className="hidden sm:flex w-[15%] min-w-[150px] relative flex-col items-center text-white gap-y-1 pt-4 shadow-lg bg-[#F3F8FF] bg-cover bg-center shrink-0">
          <div
            className={`mt-1 w-[95%] h-[40px] text-[14px] xl:text-[15px] border border-[#E7E5E4] rounded-lg flex items-center justify-center gap-x-3 px-2 font-semibold cursor-pointer whitespace-nowrap transition-colors ${activeSection === "chatbot"
              ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white"
              : "bg-white text-black"
              } `}
            onClick={() => {
              setActiveSection("chatbot");
              navigate("/botDesk");
            }}
          >
            <div className="w-[20px] h-[20px] overflow-hidden ">
              <img src={chatIcon} alt="img_sec" className="w-full h-full object-cover " />
            </div>
            Lodge Grievances
          </div>
          <div
            className={`mt-1 w-[95%] h-[40px] text-[14px] xl:text-[15px] border border-[#E7E5E4] rounded-lg flex items-center justify-center gap-x-3 px-2 font-semibold cursor-pointer whitespace-nowrap transition-colors ${activeSection === "faq"
              ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white"
              : "bg-white text-black"
              } `}
            onClick={() => {
              setActiveSection("faq");
              navigate("/faq");
            }}
          >
            <div className="w-[20px] h-[20px] overflow-hidden ">
              <img src={faqIcon} alt="img_sec" className="w-full h-full object-cover " />
            </div>
            FAQ
          </div>
          <div
            className={`mt-1 w-[95%] h-[40px] text-[14px] xl:text-[15px] rounded-lg flex items-center justify-center shadow gap-x-3 px-2 font-semibold cursor-pointer whitespace-nowrap transition-colors ${activeSection === "dashboard"
              ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white"
              : "bg-white text-black"
              } `}
            onClick={() => setActiveSection("dashboard")}
          >
            <div className="w-[18px] h-[18px] overflow-hidden ">
              <img src={activeSection === "dashboard" ? dashboardIcon2 : dashboardIcon} alt="img_sec" className="w-full h-full object-cover " />
            </div>
            Dashboard
          </div>
          <div className="mt-auto w-full flex flex-col items-center">
            <img src={sidebarImage} alt="Powered by Innovation" className="w-full max-w-[200px] h-auto opacity-70 object-contain mb-4" />
            <div className="w-[95%] mb-4 h-[40px] text-[14px] xl:text-[15px] shadow-inner rounded-3xl flex justify-center items-center px-4 font-semibold cursor-pointer transition-colors bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white">
              <Feedback />
            </div>
            <div
              className={`w-[95%] mb-4 h-[40px] text-[14px] xl:text-[15px] shadow-inner rounded-3xl flex justify-center items-center gap-x-2 px-4 font-semibold cursor-pointer transition-colors border border-[#D6D3D1] bg-[#F5F5F4] text-black `}
              onClick={handleSignOut}
            >
              <div className="w-[24px] h-[24px] overflow-hidden ">
                <img src={logoutIcon} alt="img_sec" className="w-full h-full object-cover bg-[0041C0]" />
              </div>
              Logout
            </div>
          </div>
        </div>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto">
          {activeSection === "dashboard" && <DashboardList />}
        </main>
      </div>
    </div>
  );
};

export default Desk;
